import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {AuthenticationService} from "../../services/auth.service";
import { RouterLink } from '@angular/router';

@Component({
    selector: 'kaz-slide-menu',
    templateUrl: './kaz-slide-menu.component.html',
    styleUrls: ['./kaz-slide-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class KazSlideMenuComponent implements OnInit{
  private _auth = inject(AuthenticationService);


  ngOnInit() {

  }

  isLoggedIn(){
    return this._auth.isAuthenticated();
  }
}
